/**
 * QUI CHERCHE DANS QUELLE RESSOURCE VEVIDENTAL — source unique, serveur ET écran.
 *
 * Jusqu'au 25/10, la recherche ne gardait que la session : tout compte
 * connecté, `lecture` compris, lisait les travaux et les factures avec le nom
 * des patients. Décision Dove du 25/10 :
 *
 * - seuls les rôles d'équipe ouvrent la recherche (mêmes que le module
 *   Partage : ni `comptabilite`, ni `technicien`, ni `lecture`) ;
 * - ils ne cherchent que dans une LISTE BLANCHE de référentiels, sans
 *   patient ni facture ;
 * - tout le reste — travaux, produits vendus, factures, bons de livraison,
 *   commandes, tâches, incidences, et toute ressource ajoutée demain — est
 *   réservé à `admin`. Une liste blanche ferme par défaut ; une liste noire
 *   aurait laissé passer la prochaine ressource.
 */
import { hasRole, type Role } from "./roles.js";

export const ROLES_RECHERCHE_VEVIDENTAL: readonly Role[] = [
  "admin",
  "secretariat",
  "commercial",
  "production",
  "logistique",
];

/** Ressources ouvertes à toute l'équipe : aucune ne porte de patient ni de facture. */
export const RESSOURCES_VEVIDENTAL_EQUIPE: readonly string[] = [
  "clinics",
  "doctors",
  "products",
  "materials",
  "providers",
  "technicians",
  "machines",
  "stages",
];

export function peutOuvrirRechercheVevidental(roles: readonly Role[]): boolean {
  return hasRole(roles, ...ROLES_RECHERCHE_VEVIDENTAL);
}

export function peutChercherVevidental(roles: readonly Role[], ressource: string): boolean {
  if (!peutOuvrirRechercheVevidental(roles)) return false;
  return hasRole(roles, "admin") || RESSOURCES_VEVIDENTAL_EQUIPE.includes(ressource);
}
